__turbopack_context__.v({
  "app_light_theme": "thumbs-gallery-module-scss-module__nCPW9W__app_light_theme",
  "chestniy_znak_link": "thumbs-gallery-module-scss-module__nCPW9W__chestniy_znak_link",
  "thumbsGallery": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery",
  "thumbsGallery__main": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__main",
  "thumbsGallery__navButton": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__navButton",
  "thumbsGallery__navButton--next": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__navButton--next",
  "thumbsGallery__navButton--prev": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__navButton--prev",
  "thumbsGallery__side": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__side",
  "thumbsGallery__video": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__video",
  "thumbsGallery__videoThumb": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__videoThumb",
  "thumbsGallery__videoThumbPlay": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__videoThumbPlay",
  "thumbsGallery__videoThumbWrap": "thumbs-gallery-module-scss-module__nCPW9W__thumbsGallery__videoThumbWrap",
});
